var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isTouch),expression:"isTouch"}],ref:"triggerButton",staticClass:"gh-sidebar__trigger",on:{"click":_vm.toggleSidebarOnMobile}},[_vm._v("\n    Menu\n    ")])
}
var staticRenderFns = []

export { render, staticRenderFns }